import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,

} from "@mui/material";
import { TemplateDownloadCard, CatalogDownloadCard } from "./AssignmentImportCards.jsx";

export const TemplateDownloadModal = ({
  open,
  on_close,
  template_options,
  on_template_options_change,
  on_download_template,
  is_downloading_template,
  template_error,
  catalog_options,
  on_catalog_options_change,
  on_download_catalogs,
  is_downloading_catalogs,
  catalogs_error,
  is_sys_admin,
  selected_customer,
}) => {
  return (
    <Dialog open={open} onClose={on_close} maxWidth="md" fullWidth>
      <DialogTitle>Vorlagen und Kataloge herunterladen</DialogTitle>

      <DialogContent>
        <TemplateDownloadCard
          layout="modal"
          template_options={template_options}
          on_template_options_change={on_template_options_change}
          on_download_template={on_download_template}
          is_downloading={is_downloading_template}
          template_error={template_error}
          is_sys_admin={is_sys_admin}
          selected_customer={selected_customer}
        />

        <Divider sx={{ my: 3 }} />

        <CatalogDownloadCard
          layout="modal"
          catalog_options={catalog_options}
          on_catalog_options_change={on_catalog_options_change}
          on_download_catalogs={on_download_catalogs}
          is_downloading={is_downloading_catalogs}
          catalogs_error={catalogs_error}
          is_sys_admin={is_sys_admin}
          selected_customer={selected_customer}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={on_close}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
};
